<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Create User</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="formData.email"
                label="Email"
                :disabled="loading"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="formData.roles"
                :items="roles"
                label="Roles"
                multiple
                chips
                :disabled="loading"
                required
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="loading"
          @click="onClose"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading || !formData.email || !formData.roles.length"
          @click="onSubmit"
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalCreateUser",
  props: {
    value: Boolean,
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      formData: {
        email: "",
        roles: [],
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      // Send only { email, roles } to backend
      this.$store
          .dispatch("UsersStore/createUser", {
            email: this.formData.email,
            roles: this.formData.roles,
          })
          .then(() => {
            this.$emit("on-save");
            this.onClose();
            // Optional: reset form
            this.formData.email = "";
            this.formData.roles = [];
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onClose() {
      this.dialog = false;
      // Optional: reset form
      this.formData.email = "";
      this.formData.roles = [];
    },
  },
};
</script>
